import { callkitDataReducer } from './callkitDataSlice';
export * from './callkitDataSlice';
export * from './selectors';

export const callReducers = {
    callkitData: callkitDataReducer,
};
